import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe-decorator';
import { Subscription } from 'rxjs';
import { embedPaymentCss } from 'src/app/formiobuilder/models/globalpayments.model';
import { FormObserverService } from 'src/app/formiobuilder/services/form-observer.service';
import { HeartlandObserverService } from 'src/app/formiobuilder/services/heartland-observer.service';
import { LocationSwitchService } from 'src/app/shared/services/location-switch.service';

declare var GlobalPayments: any;
@Component({
  selector: 'app-heartland-tokenizer',
  templateUrl: './heartland-tokenizer.component.html',
  styleUrls: ['./heartland-tokenizer.component.scss'],
})
export class HeartlandTokenizerComponent implements OnInit {
  locationId: number;
  cardForm: any;
  isFormValid: boolean = false;
  isEmbed: boolean = true;

  // Location based configuration
  isCCEnabled: boolean = false;
  publicAPIKey: string;
  locationData: any;

  @AutoUnsubscribe()
  private castFormvalidation$: Subscription;
  constructor(
    private formObserverService: FormObserverService,
    private router: Router,
    private heartlandObserverService: HeartlandObserverService,
    private locationSwitchService: LocationSwitchService
  ) {}

  ngOnInit(): void {
    if (this.router.url.indexOf('portal/') !== -1) {
      this.isEmbed = false;
    }

    // Get the location ID defined in the Property
    let locationIdValue = this.formObserverService.castProperty(
      'fieldset',
      'customOptions.locationId',
      'registration'
    );

    if (typeof locationIdValue === 'number') {
      this.locationId = locationIdValue;
    }

    this.castFormvalidation$ =
      this.formObserverService.castFormvalidation.subscribe(
        (isFormValid: boolean) => {
          this.isFormValid = isFormValid;
          this.toggleSubmitButton();
        }
      );

    this.init();
  }

  private init(): void {
    const locationId: number = this.locationId || 1; // get MAIN if nothing is thrown
    this.locationSwitchService.locations.subscribe((list) => {
      if (list.length) {
        this.locationData = list.find((locationData) => {
          return locationData.Id === locationId;
        });

        this.publicAPIKey = this.locationData.API_Key;
        this.isCCEnabled = this.locationData.CCEnabled;

        GlobalPayments.configure({
          publicApiKey: this.publicAPIKey,
        });

        this.renderPaymentForm();
      }
    });
  }

  private renderPaymentForm() {
    let self = this;

    if (!this.isEmbed) {
      return;
    }

    if (this.cardForm) {
      this.cardForm.dispose();
    }

    // Create Form
    this.cardForm = GlobalPayments.ui.form({
      fields: {
        'card-holder-name': {
          placeholder: 'Jane Smith',
          target: '#credit-card-card-holder',
        },
        'card-number': {
          placeholder: '•••• •••• •••• ••••',
          target: '#credit-card-card-number',
        },
        'card-expiration': {
          placeholder: 'MM / YYYY',
          target: '#credit-card-card-expiration',
        },
        'card-cvv': {
          placeholder: '•••',
          target: '#credit-card-card-cvv',
        },
        submit: {
          value: 'Process Payment',
          target: '#credit-card-submit',
        },
      },
      styles: embedPaymentCss(),
    });

    this.cardForm.on('submit', 'click', () => {
      // Trigger FormIO submission
      const formioBtn = document.querySelector("[name='data[submit]']");
      // @ts-ignore
      formioBtn.click();
      // On tokenization successful
      this.cardForm.on('card-number', 'token-success', (res: any) => {
        let tokenData: Object = {
          locationData: this.locationData,
          token: res.paymentReference,
          lastFour: res.details.cardLast4,
          cardBIN: res.details.cardBin,
          cardType: res.details.cardType,
          expMonth: res.details.expiryMonth,
          expYear: res.details.expiryYear,
        };

        self.heartlandObserverService.updateTokenData(tokenData);
      });

      // On tokenization Failed
      this.cardForm.on('card-number', 'token-error', (res: any) => {
        self.heartlandObserverService.updateTokenData({
          error: true,
          error_message: res.reasons[0].message,
        });
      });
      // resize the parent iframe when form is already rendered
      setTimeout(function () {
        if ((window as any).embed) {
          new (window as any).embed.Child({});
        }
      }, 1500);
    });
  }

  private toggleSubmitButton() {
    let formioBtn = document.querySelector("[name='data[submit]']");
    let globalPaymentBtn = document.getElementById('credit-card-submit');
    let globalPaymentFakeBtn = document.getElementById(
      'credit-card-submit-mask'
    );

    // @ts-ignore
    const isFormNotValid = formioBtn.disabled;

    this.isFormValid = !isFormNotValid;

    // @ts-ignore
    formioBtn.style.display = 'none';

    if (isFormNotValid) {
      // If form is not valid, we display the fake button
      globalPaymentBtn.style.visibility = 'hidden';
      globalPaymentFakeBtn.style.display = '';
    } else {
      // display the iFrame Button
      globalPaymentBtn.style.visibility = 'visible';
      globalPaymentFakeBtn.style.display = 'none';
    }
  }
}
